import { fontFamilyMap } from "@hl/communities-app/lib/styles/global/fonts";

import {
  BackgroundType,
  CornersShape,
  PageTheme,
} from "apollo/graphql.generated";
import { defaultLegacyTheme } from "styles/theme/index";
import { Theme } from "~/features/pages/ManagePage/state";

const findFont = (name: string) => fontFamilyMap[name] ?? name;

export const createThemeForPage = (theme: PageTheme) => {
  return {
    ...defaultLegacyTheme,
    page: {
      ...theme,
      text: {
        ...theme.text,
        fontFamily: findFont(theme.text.fontFamily),
      },
      title: {
        ...theme.title,
        fontFamily: findFont(theme.title.fontFamily),
      },
    },
  };
};

export const mapStateToPageTheme = (theme: Theme) => ({
  background: {
    color: theme.backgroundColor,
    bottomColor: theme.backgroundBottomColor,
    type: BackgroundType[theme.backgroundType as keyof typeof BackgroundType],
  },
  corners: {
    shape: CornersShape[theme.cornerShape as keyof typeof CornersShape],
  },
  text: {
    color: theme.textColor,
    fontFamily: theme.bodyFont,
  },
  title: {
    fontFamily: theme.titleFont,
  },
});

export const mapPageThemeToStateTheme = (pageTheme: PageTheme): Theme => ({
  backgroundType: pageTheme.background.type,
  backgroundColor: pageTheme.background.color,
  backgroundBottomColor: pageTheme.background.bottomColor,
  textColor: pageTheme.text.color,
  titleFont: pageTheme.title.fontFamily,
  bodyFont: pageTheme.text.fontFamily,
  cornerShape: pageTheme.corners.shape,
});
